"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../hooks");
exports.ConversionCanvasAppNavBreadcrumbs = () => {
    const { pathParams } = hooks_1.useConversionCanvas();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb.Extra, { to: `/integrations/${pathParams.cmsId}` }, () => {
            return `CMS #${pathParams.cmsId}`;
        }),
        react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb.Extra, { to: `/integrations/${pathParams.cmsId}/conversions` }, () => {
            return 'Conversions';
        }),
        react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb.Extra, { to: `/integrations/${pathParams.cmsId}/conversions/${pathParams.contentConversionId}` }, () => {
            return `#${pathParams.contentConversionId}`;
        })));
};
//# sourceMappingURL=AppNavBreadcrumbs.js.map